import { createIsMatchRegex } from '~teacher/util/regexHelpers/createIsMatchRegex';

export const isCanadaOrUSA = createIsMatchRegex(
  /^(canada|usa|us|united states)$/i // USA, US, and United States are included because of inconsistent data
);
